module.exports = __webpack_public_path__ + "img/undo.bc01144b.svg";